import vs from './project2.vertex.glsl';
export default {
  name: 'project2',
  vs: vs,
  fs: vs
};
//# sourceMappingURL=project2.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@luma.gl/shadertools/dist/esm/modules/project2/project2.js
// module id = 1502
// module chunks = 0